import { Accordion, CustomButton } from '@ui-kit'
import { NAMESPACES } from '../../utils/patient-adherence.strings'
import { SvgChart3 } from '../../../assets/svg-components/'
import PatientInformationSidePanel from './SidePanel'

const RiskAnalysis = ({
  setSelectedTabIndex,
}: {
  setSelectedTabIndex: React.Dispatch<React.SetStateAction<number>>
}) => {
  const patientData = [
    { label: 'Name', value: 'Bill Martin' },
    { label: 'Date of Birth', value: '03/10/1962' },
    {
      label: 'Address',
      value: '1234 Main St, Apt 7700, Sedona, Arkansas - 86336',
    },
  ]
  const drugData = [
    { label: 'Drug Name', value: 'Tecfidera' },
    { label: 'Drug NDC', value: '64406-0007-03' },
    {
      label: 'Drug Indication',
      value: 'Relapsing forms of Multiple Sclerosis',
    },
    { label: 'Dosage Form', value: 'Injectable' },
    { label: 'ICD10', value: 'G35: Multiple Sclerosis' },
  ]
  return (
    <div className="flex gap-2 p-4">
      <div className="flex gap-4 min-h-[40vh] border border-[#D9D9D9] rounded-lg p-4 w-[70%]">
        <div className="flex-1 flex flex-col gap-4 p-4 ">
          <div className="flex items-start">
            <span className="text-base font-semibold text-left">
              Risk Score
            </span>
          </div>
          <div className="flex flex-col items-center justify-center gap-4">
            <SvgChart3 />
            {/* <RiskChart3/> */}
            <span className="text-xs leading-6">
              The patient has a score of 3/10, indicating a low adherence risk.
              While compliance is generally acceptable, some risk of
              non-adherence remains, suggesting the need for occasional
              monitoring.
            </span>
          </div>
        </div>
        <div className="flex-[2] gap-4 p-4">
          <span className="text-base font-semibold">Risk Factor</span>
          <hr className="mb-4 mt-2" />
          <div className="flex flex-col gap-2">
            <Accordion heading="Age">
              <p className="font-light text-xs p-2">{NAMESPACES.AGE_MSG}</p>
            </Accordion>
            <Accordion heading="Health Literacy">
              <p className="font-light text-xs p-2">{NAMESPACES.HEALTH_MSG}</p>
            </Accordion>
            <Accordion heading="Financial Challenges">
              <p className="font-light text-xs p-2">
                {NAMESPACES.FINANCIAL_MSG}
              </p>
            </Accordion>
            <Accordion heading="Co - morbities">
              <p className="font-light text-xs p-2">
                {NAMESPACES.CO_MORBITIES_MSG}
              </p>
            </Accordion>
            <Accordion heading="Access & Use of Technology">
              <p className="font-light text-xs p-2">
                {NAMESPACES.TECHNOLOGY_MSG}
              </p>
            </Accordion>
          </div>
        </div>
      </div>
      <div className="right w-[30%]">
        <PatientInformationSidePanel
          header="Patient Information"
          data={patientData}
        />
        <PatientInformationSidePanel
          header="Drug Information"
          data={drugData}
        />
        <CustomButton
          color="primary"
          isFilled={true}
          size="small"
          widthClass="w-fit mt-2"
          onClick={() => setSelectedTabIndex(0)}
        >
          <span>View Full Profile</span>
        </CustomButton>
      </div>
    </div>
  )
}

export default RiskAnalysis
